<template>
  <div>
    <el-select
      :style="styles"
      :size="size"
      v-model="val"
      filterable
      :multiple="multiple"
      :disabled="disabled"
      :placeholder="placeholder"
      clearable
      @clear="handlerClear"
      @change="handlerChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
      >
        <span style="float: left">{{ item.label }}</span>
        <span v-if="item.showSpan" style="float: right; color: #8492a6; font-size: 13px"
          >已删除</span
        >
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import { getMerchantList, getAllMerchantList } from '@/api/public'
  import { getShowSpan, getDisabled } from './utils.merchant'
  import { cloneDeep } from 'lodash-es'
  import { transFormDataType } from '../utils'
  export default {
    name: 'ComMerchantSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      size: {
        type: String,
        default: ''
      },
      // 是否展示已删除供应商
      showDelete: {
        type: Boolean,
        default: false
      },
      // 是否可选已删除供应商
      isCheckDelete: {
        type: Boolean,
        default: false
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // 是否数据隔离
      insulate: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: '请选择供应商'
      },
      styles: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        val: undefined,
        list: []
      }
    },
    computed: {
      options() {
        let l = cloneDeep(this.list)
        // 如果展示已删除，则不过滤
        if (this.showDelete) {
          return l
        }
        l = l.filter((item) => !item.disabled)
        return l
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = this.insulate
          ? await getMerchantList({ includeDel: this.showDelete })
          : await getAllMerchantList()
        if (code !== 0) {
          return
        }
        const records = data
        if (!Array.isArray(records)) {
          return
        }
        const l = records.map((item) => {
          const obj = {
            value: item.merchantId || item.id + '',
            label: item.merchantName || item.name,
            disabled: getDisabled(item, this.isCheckDelete),
            showSpan: getShowSpan(item, this.isCheckDelete),
            ...item
          }
          return obj
        })
        this.list = l
      },
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item.value)
        this.$emit('change', item)
      },
      handlerClear() {
        this.$emit('clear')
      }
    }
  }
</script>

<style lang="scss" scoped></style>
